import React from "react";
import "./Frame114.css";
import { Link } from "react-router-dom";

function Frame114() {
  return (
    <div className="frame-114-71">
      <Link to="/functional-view-1">
        <div className="functional-view-4 valign-text-middle inter-medium-white-18px">Modeling</div>
      </Link>
    </div>
  );
}

export default Frame114;
